export default ([arg1, arg2]) => arg1 < arg2;
